var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvironmentImported(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 70,
    fill: "none",
    viewBox: "0 0 200 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 199.967,
    height: 69,
    x: 0.033,
    y: 0.063,
    fill: "url(#environment-imported_svg__a)",
    rx: 6.266
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#environment-imported_svg__b)",
    d: "M.033 6.328A6.266 6.266 0 0 1 6.299.063h52.398v69H6.299a6.266 6.266 0 0 1-6.266-6.266z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M43.765 25.93v-5.157a2 2 0 0 0-2-2h-26a2 2 0 0 0-2 2v25.053a2 2 0 0 0 2 2h26a2 2 0 0 0 2-2v-4.082m-20.4-7.814h22.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "m29.365 26.352-6.572 6.917a1 1 0 0 0-.026 1.348l6.598 7.525"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.872 6.328a5.09 5.09 0 0 1 5.09-5.09h128.772a5.09 5.09 0 0 1 5.091 5.09v56.469a5.09 5.09 0 0 1-5.091 5.09H64.963a5.09 5.09 0 0 1-5.091-5.09z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D0A2",
    fillOpacity: 0.1,
    d: "M59.872 6.328a5.09 5.09 0 0 1 5.09-5.09h128.772a5.09 5.09 0 0 1 5.091 5.09v56.469a5.09 5.09 0 0 1-5.091 5.09H64.963a5.09 5.09 0 0 1-5.091-5.09z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#environment-imported_svg__c)",
    strokeWidth: 2.35,
    d: "M59.872 6.328a5.09 5.09 0 0 1 5.09-5.09h128.772a5.09 5.09 0 0 1 5.091 5.09v56.469a5.09 5.09 0 0 1-5.091 5.09H64.963a5.09 5.09 0 0 1-5.091-5.09z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#618DA5",
    fillRule: "evenodd",
    d: "M107.061 45.405c0 .293-.24.53-.537.53h-5.389a.533.533 0 0 1-.537-.53v-21.75c0-.294.24-.531.537-.531h5.389c.297 0 .537.237.537.53zm8.474-16.355c0 .297-.24.537-.536.537h-5.39a.537.537 0 0 1-.537-.537v-5.39c0-.296.241-.536.537-.536h5.39c.296 0 .536.24.536.537zm8.298-2.696a3.231 3.231 0 1 1-6.462 0 3.231 3.231 0 0 1 6.462 0",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#01B8BA",
    fillRule: "evenodd",
    d: "M115.535 37.257c0 .297-.24.537-.536.537h-5.39a.537.537 0 0 1-.537-.537v-5.39c0-.296.241-.536.537-.536h5.39c.296 0 .536.24.536.537zm8.298-2.696a3.231 3.231 0 1 1-6.462 0 3.231 3.231 0 0 1 6.462 0",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#618DA5",
    fillRule: "evenodd",
    d: "M115.535 45.465c0 .296-.24.536-.536.536h-5.39a.537.537 0 0 1-.537-.536v-5.39c0-.296.241-.536.537-.536h5.39c.296 0 .536.24.536.536zm8.297-2.696a3.23 3.23 0 1 1-6.46 0 3.23 3.23 0 0 1 6.46 0",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#01B8BA",
    d: "M138.553 39.563h-1.503V38.41c-.602.802-1.571 1.353-2.64 1.353-2.106 0-3.61-1.587-3.61-4.227 0-2.59 1.504-4.245 3.61-4.245 1.036 0 1.988.502 2.64 1.37v-4.244h1.503zm-1.503-2.306v-3.442c-.418-.652-1.32-1.187-2.239-1.187-1.504 0-2.44 1.22-2.44 2.908 0 1.67.936 2.89 2.44 2.89.919 0 1.821-.518 2.239-1.17m3.41-1.738c0-2.34 1.688-4.227 4.044-4.227 2.423 0 3.927 1.888 3.927 4.36v.368h-6.383c.117 1.37 1.119 2.506 2.74 2.506.852 0 1.788-.334 2.389-.952l.702.986c-.802.785-1.938 1.203-3.241 1.203-2.406 0-4.178-1.704-4.178-4.244m4.044-2.991c-1.621 0-2.389 1.303-2.473 2.406h4.929c-.033-1.07-.752-2.406-2.456-2.406m9.567 7.035h-1.621l-3.325-8.071h1.604l2.523 6.333 2.523-6.333h1.621z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "environment-imported_svg__a",
    x1: 100.016,
    x2: 100.016,
    y1: 0.063,
    y2: 164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "environment-imported_svg__b",
    x1: 29,
    x2: 29,
    y1: 0,
    y2: 163.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "environment-imported_svg__c",
    x1: 93,
    x2: 93,
    y1: 0,
    y2: 163.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentImported);
export default __webpack_public_path__ + "static/media/environment-imported.2bf00af518e75e859c0cf7c58f951b8c.svg";
export { ForwardRef as ReactComponent };